import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation, Trans } from 'react-i18next';

import { Flex, Image, Text, ButtonFilled, ButtonText } from 'Components/Base';

const ClearExitConfirmationContent = ({ onConfirm, onCancel }) => {
  const { t } = useTranslation('classroom');
  return (
    <Flex width={1} flexDirection={'column'} alignItems={'center'} height="100%">
      <Image maxWidth={140} src="/assets/images/not_found.png" />
      <Flex width={1} flexDirection={'column'} alignItems={'center'}>
        <Text textStyle={'heading2'} mt={6} textAlign={'center'}>
          {t('CLEAR_BY_ONDEMAND.CLEAR_EXIT_CONFIRMATION_MODAL.TITLE')}
        </Text>
        <Text mt={4} textAlign={'center'}>
          <Trans
            defaults={t('CLEAR_BY_ONDEMAND.CLEAR_EXIT_CONFIRMATION_MODAL.DESCRIPTION')}
            components={[<br key="subtitle" />]}
          />
        </Text>
      </Flex>
      <ButtonFilled onClick={onConfirm} mt="auto" width={1} borderRadius="8px" maxWidth={'300px'}>
        {t('CLEAR_BY_ONDEMAND.CLEAR_EXIT_CONFIRMATION_MODAL.EXIT_CLEAR')}
      </ButtonFilled>
      <ButtonText onClick={onCancel} mt={4} py={0} px={0} width={1} maxWidth={'300px'}>
        {t('CLEAR_BY_ONDEMAND.CLEAR_EXIT_CONFIRMATION_MODAL.BACK_TO_CLEAR')}
      </ButtonText>
    </Flex>
  );
};

ClearExitConfirmationContent.propTypes = {
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
};

export default ClearExitConfirmationContent;
